import React, { memo } from 'react'

import { makeStyles } from '@material-ui/styles'
import JobProfile from '../../jobProfile'
import { StoreValue } from 'store'

import styles from '../styles'

const useStyles = makeStyles(styles)

const Step4: React.FunctionComponent<any> = props => {
	const { job, resetSteps, handleEditJobDetails } = props
	const {
		id,
		team,
		title,
		expiryDate,
		jobDescription,
		jobCompany,
		contractType,
		jobType,
		jobTypeLoc,
		skills,
		seniorityLevel,
		salary,
		benefits,
		featuredImage,
		featuredVideo,
		locations,
		teamLeader,
		applyJobExternalUrl,
	} = job

	const classes = useStyles()

	const getNrHours = () => {
		switch (contractType) {
			case 'FullTime':
				return '40/week'
			case 'PartTime':
				return '20/week'
			case 'ProjectBased':
				return 'Project Based'
			case 'OneTime':
				return 'One Time'
		}
	}

	const jobDetails = {
		company: jobCompany,
		team,
		job: {
			id,
			title,
			expiryDate,
			skills,
			benefits,
			jobDescription,
			salary,
			contractType,
			nrHours: getNrHours(),
			seniorityLevel,
			jobType,
			jobTypeLoc,
			featuredImage,
			featuredVideo,
			team,
			locations,
			teamLeader,
			applyJobExternalUrl,
		},
	}
	return (
		<div className={classes.jobReviewContainer}>
			<JobProfile
				resetSteps={resetSteps}
				isCreating={true}
				jobDetails={jobDetails}
				handleEditJobDetails={handleEditJobDetails}
			></JobProfile>
		</div>
	)
}
export default memo((props: any) => (
	<StoreValue keys={['job']}>
		<Step4 {...props} />
	</StoreValue>
))
